import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import ProfileDropdown from '../../components/ProfileDropdown';
import { FaBars } from 'react-icons/fa';

const Navbar = ({ toggleSidebar, isSidebarVisible }) => {
    const { t } = useTranslation();
    
    return (
        <nav
            className='flex fixed w-full p-5 z-10 items-center justify-between bg-antiFlashWhite bg-opacity-30 backdrop-blur-md space-x-5'
        >
            <div className='flex'>
                <button
                    className={`
                        ${isSidebarVisible ? 'lg:ml-64' : 'ml-0'}
                        hover:outline-none hover:text-primary focus:outline-none focus:text-primary
                        transition-all duration-300
                    `}
                    onClick={toggleSidebar}>
                    <FaBars className={`h-6 w-6`} />
                </button>
            </div>
            <div className='flex items-center space-x-2'>
                <LanguageSwitcher />
                <ProfileDropdown t={t} />
            </div>
        </nav>
    );
};

export default Navbar;
